import {Component, Input, OnChanges, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Product} from "../../product-details/interface/product";
import {PriceCalculationService} from "../../product-details/service/price-calculation.service";
import {CurrencyResolverService} from "../../currency-resolver.service";
import {ProductCurrencyDropdownComponent} from "../product-currency-dropdown/product-currency-dropdown.component";
import {PipeModule} from "../../pipe/pipe.module";
import {ProductInformationService} from "../product-information-service";
import {ApCurrency} from "../../pipe/enum/ap-currency";

@Component({
  selector: 'fb-product-price',
  standalone: true,
	imports: [CommonModule, ProductCurrencyDropdownComponent, PipeModule],
  templateUrl: './product-price.component.html',
  styleUrls: ['./product-price.component.scss']
})
export class ProductPriceComponent implements OnInit, OnChanges {

	@Input()
	public product: Product = {} as Product;

	@Input()
	public price: number = 0;

	@Input()
	public discountedPrice: number = 0;
	public discountPriceForView: number = 0;

	@Input()
	public fabricSelected: boolean = false;

	public selectedCurrency: ApCurrency = ApCurrency.INR;

	public priceSummary = {
		fabric: 0,
		finish: 0,
		customSize: 0,
		consumedFabric: 0,
		makingCharges: 0
	}

	constructor(
		private _productInformation: ProductInformationService,
		public _currencyResolver: CurrencyResolverService,
	) {
	}

	ngOnInit() {
		this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		this._currencyResolver.selectCurrencyChange.subscribe(()=> {
			this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		});
	}

	ngOnChanges() {
		this.discountPriceForView = this.discountedPrice;
		this.priceSummary = {
			fabric: this._productInformation.getFabricPrice(),
			finish: this._productInformation.getTotalFinishPrice(),
			customSize: this._productInformation.getCustomSizePrice(),
			consumedFabric: this._productInformation.getConsumedFabric(),
			makingCharges: this._productInformation.getMakingCharges()
		}
	}
}
